import React from 'react';
import classNames from 'classnames';

function TextInput(props) {
  const error = props.meta.touched && props.meta.error ? 'error' : '';
  const disabled = props.disabled ? 'disabled' : '';
  const errorClass = props.className + ' small error';

  if (props.img) {
    return (
      <div className="form-field image">
        <label htmlFor={props.id}>{props.label}</label>
        <input
          {...props.input}
          id={props.id}
          name={props.name}
          className={classNames(error, disabled, props.className)}
          disabled={props.disabled ? true : false}
          placeholder={props.placeholder}
          type={props.type}
        />
        <img alt="test" src={props.img} />
        { props.meta.touched && props.meta.error && <p className={errorClass}>{props.meta.error}</p> }
      </div>
    );
  } else {
    return (
      <div className="form-field">
        <label htmlFor={props.id}>{props.label}</label>
        <input
          {...props.input}
          id={props.id}
          name={props.name}
          className={classNames(error, disabled, props.className)}
          disabled={props.disabled ? true : false}
          placeholder={props.placeholder}
          type={props.type}
        />
        { props.meta.touched && props.meta.error && <p className={errorClass}>{props.meta.error}</p> }
      </div>
    );
  }
}

TextInput.propTypes = {
  input: React.PropTypes.object,
  meta: React.PropTypes.object,
};

export default TextInput;



/** WEBPACK FOOTER **
 ** ./src/components/form-input-text/index.js
 **/